/**
 * Derives missing types for placeholders
 * @param {Array} placeholders - The placeholders to process
 * @param {Array} connectionData - The source connection data containing type information
 * @param {Object} options - Configuration options
 * @param {string} options.sourceKey - The field name to match on in placeholder (default: 'sourceKey')
 * @param {string} options.connectionPlaceholderKey - The field in connectionData that contains placeholders (default: 'placeholders')
 * @param {string} options.targetKey - The field in connection placeholders to match against (default: 'sourceKey')
 * @param {string} options.defaultType - Default type when no match is found (default: 'text')
 * @returns {Array} - Processed placeholders with types
 */
export const deriveMissingTypesInSavedPlaceholders = (
  placeholders,
  connectionData,
  {
    sourceKey = 'sourceKey',
    connectionPlaceholderKey = 'placeholders',
    targetKey = 'sourceKey',
    defaultType = 'text',
  } = {}
) => {
  if (!placeholders || !Array.isArray(placeholders)) {
    return [];
  }

  const typeByKey = {};
  if (connectionData && connectionData[connectionPlaceholderKey]) {
    connectionData[connectionPlaceholderKey].forEach(placeholder => {
      if (placeholder[targetKey] && placeholder.type) {
        typeByKey[placeholder[targetKey]] = placeholder.type;
      }
    });
  }

  return placeholders.map(placeholder => {
    if (placeholder.type) {
      return placeholder;
    }

    return {
      ...placeholder,
      type: typeByKey[placeholder[sourceKey]] || defaultType,
    };
  });
};
